import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgStar(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_5004_25832)">
        <path
          d="M17 11.43V3H7V11.43C7 11.78 7.18 12.11 7.49 12.29L11.67 14.8L10.68 17.14L7.27 17.43L9.86 19.67L9.07 23L12 21.23L14.93 23L14.15 19.67L16.74 17.43L13.33 17.14L12.34 14.8L16.52 12.29C16.82 12.11 17 11.79 17 11.43ZM11 12.07L9 10.87V5H11V12.07ZM15 10.87L13 12.07V5H15V10.87Z"
          fill="#F19A09"
        />
      </g>
      <defs>
        <clipPath id="clip0_5004_25832">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
